<!--
 * @Description: 头部
 * @Date: 2020-07-15 17:57:24
-->

<template>
  <div class="bi-footer">
    <lBiTitle title="信息披露"></lBiTitle>
    <div class="bi-footer-block">
      <p class="title">服务公司声明</p>
      <p>
        本公司以勤勉的职业态度，独立、客观地出具本报告。本报告所采用的数据和信息均来自项目执行采集，本公司不保证该等信息的准确性或完整性。分析逻辑基于团队的职业理解，清晰准确地反映了本公司的观点，结论不受任何第三方的授意或影响，特此声明。
      </p>
      <p class="title">法律声明</p>
      <p>
        本报告仅供本公司的客户使用。本公司不会因接收人收到本报告而视其为本公司的当然客户。
      </p>
      <p>
        本报告所载的资料仅反映本公司截止发布本报告当日的判断。在不同时期，本公司可发出与本报告所载资料不一致的报告。
      </p>
      <p>
        本报告的版权归本公司所有，未经书面许可，任何机构和个人不得以任何形式翻版、复制、发表或引用，或再次分发给任何其他人，或以任何侵犯本公司版权的其他方式使用。
      </p>
      <p>
        本公司将尽商业上合理水平的技能和注意义务为平台用户提供稳定的技术服务，但不对服务内容本身承担责任。
      </p>
    </div>
  </div>
</template>

<script>
import lBiTitle from './common/title';
export default {
  components: {
    lBiTitle
  }
};
</script>

<style scoped lang="scss">
@import '~@/styles/mixin.scss';
.bi-footer {
  width: 100%;
  height: 550px;
  .bi-footer-block {
    border: 4px solid rgba($color: #303030, $alpha: 1);
    padding: 40px 60px;
    position: relative;
    &::before {
      content: '';
      width: calc(100% - 22px);
      height: calc(100% - 22px);
      border: 2px solid rgba($color: #303030, $alpha: 1);
      pointer-events: none;
      @include absolute_mid();
    }
    & > p {
      font-size: 14px;
      color: #666666;
      line-height: 24px;
      text-align: left;
      letter-spacing: 2px;
      &.title {
        font-size: 16px;
        color: #333333;
        margin-bottom: 16px;
        margin-top: 20px;
        font-weight: bold;
        letter-spacing: 1px;
        &:first-of-type {
          margin-top: 0;
        }
      }
    }
  }
}
</style>
